import React, { useEffect } from 'react';

const NewHome = () => {
  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true
      });
    }

    // Initialize Feather icons
    if (window.feather) {
      window.feather.replace();
    }

    // Mobile menu toggle
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (mobileMenuButton && mobileMenu) {
      mobileMenuButton.addEventListener('click', function() {
        if (mobileMenu.classList.contains('hidden')) {
          mobileMenu.classList.remove('hidden');
          if (window.feather) window.feather.replace();
        } else {
          mobileMenu.classList.add('hidden');
        }
      });
    }
  }, []);

  return (
    <div className="font-sans antialiased">
      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <i data-feather="zap" className="text-purple-600 h-8 w-8"></i>
                <span className="ml-2 text-xl font-bold text-gray-900">InnovexNow</span>
              </div>
            </div>
            <div className="hidden md:ml-6 md:flex md:items-center md:space-x-8">
              <a href="#services" className="text-gray-900 hover:text-purple-600 px-3 py-2 text-sm font-medium">Services</a>
              <a href="#solutions" className="text-gray-900 hover:text-purple-600 px-3 py-2 text-sm font-medium">Solutions</a>
              <a href="#packages" className="text-gray-900 hover:text-purple-600 px-3 py-2 text-sm font-medium">Packages</a>
              <a href="#about" className="text-gray-900 hover:text-purple-600 px-3 py-2 text-sm font-medium">About</a>
              <a href="#contact" className="bg-purple-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-purple-700 transition duration-300">Contact Us</a>
            </div>
            <div className="-mr-2 flex items-center md:hidden">
              <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" id="mobile-menu-button">
                <i data-feather="menu"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="hidden md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a href="#services" className="text-gray-900 hover:text-purple-600 block px-3 py-2 rounded-md text-base font-medium">Services</a>
            <a href="#solutions" className="text-gray-900 hover:text-purple-600 block px-3 py-2 rounded-md text-base font-medium">Solutions</a>
            <a href="#packages" className="text-gray-900 hover:text-purple-600 block px-3 py-2 rounded-md text-base font-medium">Packages</a>
            <a href="#about" className="text-gray-900 hover:text-purple-600 block px-3 py-2 rounded-md text-base font-medium">About</a>
            <a href="#contact" className="bg-purple-600 text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-purple-700 transition duration-300">Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 text-white py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="md:flex md:items-center md:justify-between">
            <div className="md:w-1/2" data-aos="fade-right">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">Empowering Businesses with Digital Innovation</h1>
              <p className="text-xl mb-8">Complete digital solutions for startups, SMEs, and enterprises to establish a strong digital presence.</p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <a href="#contact" className="bg-white text-purple-600 hover:bg-gray-100 px-6 py-3 rounded-md text-lg font-semibold transition duration-300 text-center">Get Started</a>
                <a href="#services" className="border-2 border-white text-white hover:bg-white hover:text-purple-600 px-6 py-3 rounded-md text-lg font-semibold transition duration-300 text-center">Our Services</a>
              </div>
            </div>
            <div className="hidden md:block md:w-1/2" data-aos="fade-left">
              <div className="bg-white/10 backdrop-blur-lg rounded-lg p-8 shadow-xl">
                <div className="text-center">
                  <i data-feather="zap" className="h-24 w-24 text-white mx-auto mb-4"></i>
                  <h3 className="text-2xl font-bold mb-2">Digital Solutions</h3>
                  <p className="text-white/80">Transforming businesses with technology</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted By Section */}
      <section className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-gray-500 mb-8">Trusted by businesses worldwide</p>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            {[
              { icon: "briefcase", label: "Startups" },
              { icon: "shopping-bag", label: "SMEs" },
              { icon: "home", label: "Retailers" },
              { icon: "user", label: "Entrepreneurs" },
              { icon: "layers", label: "Enterprises" }
            ].map((item, index) => (
              <div key={index} className="flex justify-center">
                <div className="h-12 flex items-center">
                  <i data-feather={item.icon} className="h-8 w-8 text-purple-600"></i>
                  <span className="ml-2 text-lg font-semibold">{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Our Comprehensive Services</h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">Everything you need to establish and grow your digital presence</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "shopping-cart", title: "eCommerce Development", desc: "Custom online stores with seamless shopping experiences, secure payments, and inventory management." },
              { icon: "smartphone", title: "Mobile App Development", desc: "Native Android & iOS applications to engage customers on all devices with premium performance." },
              { icon: "bar-chart-2", title: "Admin Dashboards", desc: "Powerful control panels to manage your business operations, analytics, and customer data." },
              { icon: "trending-up", title: "Digital Marketing", desc: "Comprehensive strategies including SEO, SEM, social media, and ads to drive traffic and sales." },
              { icon: "cpu", title: "AI Business Tools", desc: "Smart analytics, chatbots, and product recommendations to enhance customer experience." },
              { icon: "cloud", title: "Cloud & API Integrations", desc: "Seamless connections with CRM, ERP, shipping, and payment systems for unified operations." }
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-2" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="p-8">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i data-feather={service.icon} className="h-8 w-8 text-purple-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">{service.title}</h3>
                  <p className="text-gray-600 text-center">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section id="solutions" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Tailored Solutions for Your Business</h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">We understand different businesses have different needs</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md" data-aos="fade-right">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">For Startups</h3>
              <p className="text-gray-600 mb-6">Launch your online business quickly with our cost-effective starter packages that include everything you need to go live.</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>Quick deployment</span>
                </li>
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>Budget-friendly options</span>
                </li>
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>Basic training & onboarding</span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md" data-aos="fade-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">For Enterprises</h3>
              <p className="text-gray-600 mb-6">Advanced, scalable solutions with AI-powered features and enterprise-grade security for your growing business.</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>Custom development</span>
                </li>
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>AI-driven analytics</span>
                </li>
                <li className="flex items-start">
                  <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                  <span>24/7 premium support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="py-20 bg-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-3xl font-extrabold sm:text-4xl">Why Choose InnovexNow?</h2>
            <p className="mt-4 max-w-2xl text-xl opacity-90 mx-auto">Our unique approach to digital business solutions</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: "box", title: "One-Stop Solution", desc: "Everything from setup to promotion under one roof." },
              { icon: "activity", title: "AI-Powered Growth", desc: "Smarter eCommerce through automation & insights." },
              { icon: "layers", title: "Scalable Packages", desc: "Start small and upgrade anytime as your business grows." }
            ].map((item, index) => (
              <div key={index} className="text-center" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="bg-purple-600 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
                  <i data-feather={item.icon} className="h-8 w-8"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="opacity-90">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section id="packages" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Flexible Packages for Every Business</h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">Start small and scale as you grow</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { name: "Starter", price: "₹50,000", features: ["eCommerce Website", "Admin Controller"], popular: false },
              { name: "Growth", price: "₹1,20,000", features: ["Website + Admin Panel", "Android App", "Basic Training"], popular: true },
              { name: "Premium", price: "₹2,50,000", features: ["Website + Admin Panel", "Android & iOS Apps", "Digital Marketing Support", "AI Product Recommendations"], popular: false },
              { name: "Enterprise", price: "Custom", features: ["All Premium Features", "Tailored Digital Marketing", "AI Analytics Dashboard", "API Integrations", "Ongoing Support"], popular: false }
            ].map((pkg, index) => (
              <div key={index} className={`bg-white rounded-xl shadow-md overflow-hidden transition duration-300 transform hover:scale-105 ${pkg.popular ? 'border-2 border-purple-500 relative' : 'border border-gray-200'}`} data-aos="fade-up" data-aos-delay={index * 100}>
                {pkg.popular && <div className="absolute top-0 right-0 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">Popular</div>}
                <div className="p-6 text-center">
                  <h3 className="text-lg font-medium text-gray-900">{pkg.name}</h3>
                  <div className="mt-4 flex items-center justify-center">
                    <span className="text-4xl font-extrabold text-gray-900">{pkg.price}</span>
                  </div>
                  <ul className="mt-6 space-y-3">
                    {pkg.features.map((feature, i) => (
                      <li key={i} className="flex items-start justify-center">
                        <i data-feather="check" className="text-green-500 mr-2 mt-1 h-4 w-4"></i>
                        <span className="text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="mt-8 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 transition duration-300">
                    {pkg.name === 'Enterprise' ? 'Contact Us' : 'Get Started'}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="lg:col-span-5" data-aos="fade-right">
              <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg p-8 shadow-xl">
                <div className="text-center">
                  <i data-feather="users" className="h-24 w-24 text-purple-600 mx-auto mb-4"></i>
                  <h3 className="text-2xl font-bold mb-2">Our Team</h3>
                  <p className="text-gray-600">Dedicated professionals working for your success</p>
                </div>
              </div>
            </div>
            <div className="mt-12 lg:mt-0 lg:col-span-7" data-aos="fade-left">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">About InnovexNow</h2>
              <div className="mt-6 text-gray-600 space-y-6">
                <p>InnovexNow is a digital solutions provider specializing in end-to-end eCommerce platforms and business transformation tools. We empower businesses to establish a strong digital presence through scalable technology, AI-driven systems, and growth-focused strategies.</p>
                <p>Our mission is delivering scalable eCommerce platforms, AI-driven tools, and marketing strategies that help businesses grow faster and smarter.</p>
                <p>Our vision is to become the world's most trusted partner for digital business transformation, empowering businesses with innovation and growth.</p>
              </div>
              <div className="mt-8">
                <a href="#contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 transition duration-300">
                  Learn More About Us
                  <i data-feather="arrow-right" className="ml-2 h-4 w-4"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">What Our Clients Say</h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">Success stories from businesses we've helped transform</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { name: "Rajesh Kumar", company: "Founder, UrbanFashion", text: "InnovexNow helped us launch our eCommerce store in just 4 weeks. Their platform is easy to use and their support team is always available when we need help." },
              { name: "Priya Sharma", company: "CEO, OrganicHarvest", text: "The AI product recommendations feature has increased our sales by 35%. The mobile app they developed has significantly improved customer engagement." },
              { name: "Amit Patel", company: "Director, TechSolutions", text: "Their enterprise package gave us exactly what we needed - a scalable platform with robust analytics and seamless API integrations with our existing systems." }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-md" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="flex items-center mb-4">
                  <div className="flex-shrink-0">
                    <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center">
                      <i data-feather="user" className="h-6 w-6 text-purple-600"></i>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-medium text-gray-900">{testimonial.name}</h4>
                    <p className="text-gray-500">{testimonial.company}</p>
                  </div>
                </div>
                <p className="text-gray-600">{testimonial.text}</p>
                <div className="mt-4 flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} data-feather="star" className="h-5 w-5 fill-current"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold sm:text-4xl" data-aos="fade-up">
            Ready to Transform Your Business?
          </h2>
          <p className="mt-4 max-w-2xl text-xl opacity-90 mx-auto" data-aos="fade-up" data-aos-delay="100">
            Get started with InnovexNow today and take your business to the next level.
          </p>
          <div className="mt-8" data-aos="fade-up" data-aos-delay="200">
            <a href="#contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-purple-600 bg-white hover:bg-gray-100 transition duration-300">
              Contact Our Team
              <i data-feather="arrow-right" className="ml-2 h-4 w-4"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8">
            <div className="mb-12 lg:mb-0" data-aos="fade-right">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Get In Touch</h2>
              <p className="mt-4 text-lg text-gray-600">
                Have questions about our services or packages? Fill out the form and our team will get back to you within 24 hours.
              </p>
              <div className="mt-8 space-y-6">
                {[
                  { icon: "mail", title: "Email", info: "contact@innovexnow.com" },
                  { icon: "phone", title: "Phone", info: "+91 98765 43210" },
                  { icon: "map-pin", title: "Office", info: "123 Business Park, Sector 22, Gurugram, Haryana 122001" }
                ].map((contact, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0">
                      <i data-feather={contact.icon} className="h-6 w-6 text-purple-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">{contact.title}</h3>
                      <p className="text-gray-600">{contact.info}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div data-aos="fade-left">
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">Your Name</label>
                  <input type="text" id="name" name="name" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-purple-500 focus:border-purple-500" />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
                  <input type="email" id="email" name="email" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-purple-500 focus:border-purple-500" />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
                  <input type="tel" id="phone" name="phone" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-purple-500 focus:border-purple-500" />
                </div>
                <div>
                  <label htmlFor="business" className="block text-sm font-medium text-gray-700">Business Type</label>
                  <select id="business" name="business" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-purple-500 focus:border-purple-500">
                    <option>Startup</option>
                    <option>SME</option>
                    <option>Enterprise</option>
                    <option>Retailer</option>
                    <option>Other</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
                  <textarea id="message" name="message" rows="4" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-purple-500 focus:border-purple-500"></textarea>
                </div>
                <div>
                  <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition duration-300">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">InnovexNow</h3>
              <p className="text-gray-400">Empowering businesses with digital innovation through scalable technology and AI-driven solutions.</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">eCommerce Development</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">Mobile Apps</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">Digital Marketing</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">AI Business Tools</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">About Us</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">Careers</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">Blog</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition duration-300">Contact</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Connect</h3>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition duration-300">
                  <i data-feather="facebook" className="h-5 w-5"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition duration-300">
                  <i data-feather="twitter" className="h-5 w-5"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition duration-300">
                  <i data-feather="linkedin" className="h-5 w-5"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition duration-300">
                  <i data-feather="instagram" className="h-5 w-5"></i>
                </a>
              </div>
              <div className="mt-4">
                <p className="text-gray-400">Subscribe to our newsletter</p>
                <div className="mt-2 flex">
                  <input type="email" placeholder="Your email" className="px-3 py-2 text-gray-900 rounded-l-md focus:outline-none w-full" />
                  <button className="bg-purple-600 text-white px-4 py-2 rounded-r-md hover:bg-purple-700 transition duration-300">
                    <i data-feather="send" className="h-4 w-4"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2023 InnovexNow. All rights reserved.</p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">Cookie Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewHome;